import { Head, useForm } from '@inertiajs/react';

import { Btn } from '@/Components/Btn';
import { PublicLayout } from '@/Layouts/PublicLayout';

type Props = {
    status?: string | null;
};

export default function RequestPasswordReset({ status }: Props) {
    const form = useForm({ email: '' });

    function submit(e: React.FormEvent) {
        e.preventDefault();
        form.post('/forgot-password');
    }

    return (
        <PublicLayout>
            <Head title="Reset password" />
            <div className="max-w-md mx-auto px-6 py-12">
                <h1 className="text-[28px] leading-tight text-ink mb-3">Reset password</h1>
                <p className="text-ink-soft text-[14px] mb-6">
                    Enter your email. If an account exists, we&apos;ll send a reset link.
                </p>
                {status && <div className="mb-4 text-[14px] text-emerald-700">{status}</div>}
                <form onSubmit={submit} className="space-y-4">
                    <input
                        type="email"
                        required
                        autoComplete="email"
                        value={form.data.email}
                        onChange={(e) => form.setData('email', e.target.value)}
                        className="w-full p-2 border border-rule rounded bg-card"
                        placeholder="you@example.com"
                    />
                    <Btn type="submit" full loading={form.processing}>
                        Send reset link
                    </Btn>
                </form>
            </div>
        </PublicLayout>
    );
}
